import { render, staticRenderFns } from "./MportsForm.vue?vue&type=template&id=164f3e60"
import script from "./MportsForm.vue?vue&type=script&lang=js"
export * from "./MportsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports